import React, { useEffect } from "react";

import SideBar from "../../components/your_wishes/Sidebar";
import SuggestionBox from "../../common/suggestionBox/SuggestionBox";

import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import { resetCard } from "../../redux/slices/CardSlices";
import { connect } from "react-redux";
import { resetTab } from "../../redux/slices/TabSlices";
import { Toaster } from "react-hot-toast";
import styled from "@emotion/styled";

const CustomGrid = styled(Grid)`
  & .css-1g58wl8-MuiGrid-root {
    margin-top: 0px !important;
  }
`;
const YourWishes = ({ resetCard, resetTab }) => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (!localStorage.getItem("token") && !localStorage.getItem("auth")) {
      navigate("/");
    }
  }, [navigate]);
  useEffect(() => {
    resetCard();
    resetTab();
  }, [location.pathname]);

  return (
    <>
      <Toaster />
      <Box className="family-tree-main-container" sx={{ paddingBottom: "0px" }}>
        <CustomGrid
          container
          spacing={5}
          className="balance-of-assets status-quo"
          sx={{ marginTop: "0px" }}
        >
          <Grid item xl={1} lg={1} sm={12} xs={12}>
            {/* <SuggestionBox showBulbIcon={false} /> */}
          </Grid>
          <Grid item xl={2} lg={2} sm={12} xs={12} className="side-bar-status">
            <SideBar />
          </Grid>
          <Grid item xl={8} lg={8} sm={12} xs={12} marginTop="-0.7rem">
            <Outlet />
          </Grid>
        </CustomGrid>
      </Box>
    </>
  );
};

function mapStateToProps(state) {
  return {
    currentTab: state.currentTab.currentTab,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    resetCard: () => dispatch(resetCard()),
    resetTab: () => dispatch(resetTab()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(YourWishes);
